import { Checkbox, Tooltip } from 'antd';
import React from 'react';
export const CheckBox = ({ text, tooltip, checked, onChange, style, }) => {
    return (React.createElement(Tooltip, { title: tooltip },
        React.createElement("div", null,
            React.createElement(Checkbox, { value: text, onChange: () => onChange(!checked), style: { ...style }, checked: checked }, text))));
};
